<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Add Items</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="item_name"
                type="text"
                name="item_name"
                id="item_name"
              />
              <label>Item Name</label>
            </div>
          </div>
        </div>

         <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="alt_item_name"
                type="text"
                name="alt_item_name"
                id="alt_item_name"
              />
              <label>Alt. Item Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <multiselect
              class="selectCinemaDandD"
              v-model="selectedCategory"
              :placeholder="''"
              :options="Categories"
              @select="onSelectCategory($event, 'select')"
              @remove="onSelectCategory($event, 'remove')"
              label="category_name"
              track-by="category_id"
              selectLabel="Select"
              deselectLabel="✖"
              :multiple="false"
            ></multiselect>
            <label :class="selectedCategory ? 'shift-up' : ''">
              {{ "Category" }}
            </label>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="item_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="billing-items"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      Categories: [],
      selectedCategory: "",
      item_name: "",
      alt_item_name: "",
      category_id: null,
      item_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    this.getAllItemCategories();
  },
  methods: {
    onSelectCategory(category, type) {
      if (type == "remove") {
        this.category_id = null;
        this.selectedCategory = "";
      } else {
        this.category_id = category.category_id;
        this.selectedCategory = category;
      }
    },
    getAllItemCategories() {
      MasterService.GetAllManualBiilingCategory()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Categories = data.Records;
          } else {
            this.$toasted.show("No Categories Found");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.item_name) {
        return this.$toasted.show("Please Enter Item Name");
      } else if (!this.category_id) {
        return this.$toasted.show("Please Select Category");
      } else {
        let payload = {
          item_name: this.item_name,
          alt_item_name: this.alt_item_name,
          category_id: this.category_id,
          item_is_active: this.item_is_active || "Y",
        };
        MasterService.AddManualBiilingItem(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "billing-items",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    resetForm: function () {
      this.item_name = "";
      this.alt_item_name = "";
      this.category_id = null;
      this.item_is_active = "Y";
      this.btenable = false;
      this.selectedCategory = "";
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ManualBillingComponents/addManualBillingItems.vue